import { createFileRoute } from "@tanstack/react-router";
import { Link } from "@tanstack/react-router";

import { PresentationViewer } from "../components/presentation/PresentationViewer";
import { SITE_URL, buildMeta } from "../lib/site";
import { routes } from "../lib/nav";

const title = "Презентация HAY.agency — digital-системы для роста продаж";
const description =
  "Презентация HAY.agency: сайт, реклама, CRM и аналитика как единая система роста продаж. Услуги, кейсы и стоимость — 23 слайда.";

export const Route = createFileRoute("/presentation")({
  head: () => ({
    ...buildMeta({
      title,
      description,
      path: "/presentation",
      image: `${SITE_URL}/presentation/slide-01.webp`,
      imageAlt: "Презентация HAY.agency — обложка",
      locale: "ru_RU",
      noindex: true,
    }),
  }),
  component: PresentationPage,
});

function PresentationPage() {
  return (
    <main className="bg-foreground text-background">
      {/* Шапка страницы */}
      <header className="mx-auto flex flex-col gap-6 px-5 pb-10 pt-14 md:flex-row md:items-end md:justify-between lg:px-[21px] lg:pt-24">
        <div>
          <nav
            aria-label="Хлебные крошки"
            className="text-[11px] font-medium uppercase tracking-[0.12em] text-background/40"
          >
            <Link to="/" className="transition-colors hover:text-brand-text">
              Главная
            </Link>
            <span aria-hidden="true" className="mx-2">/</span>
            <span className="text-background/70">Презентация</span>
          </nav>
          <h1 className="mt-4 max-w-[720px] text-[32px] font-semibold leading-[1.08] tracking-[-1.6px] md:text-[48px] md:tracking-[-2.4px]">
            Увеличивайте продажи за счёт цифровой стратегии роста
          </h1>
        </div>
        <p className="max-w-[300px] text-[13px] leading-[19px] text-background/50">
          Сайт → Реклама → CRM → Аналитика = стабильный поток качественных
          заявок и рост ROI. Листайте стрелками или свайпом.
        </p>
      </header>

      <PresentationViewer />

      {/* Финальный CTA */}
      <section className="mx-auto flex flex-col items-start gap-8 px-5 py-16 md:flex-row md:items-center md:justify-between lg:px-[21px] lg:py-24">
        <h2 className="max-w-[560px] text-[28px] font-semibold leading-[1.12] tracking-[-1.4px] md:text-[40px] md:tracking-[-2px]">
          Обсудим вашу задачу за 40 минут
        </h2>
        <Link
          to={routes.contacts}
          hash="event"
          className="btn-label inline-flex items-center justify-center bg-brand px-8 py-[16px] text-brand-foreground transition-colors duration-300 hover:bg-background hover:text-foreground"
        >
          Обсудить проект
        </Link>
      </section>
    </main>
  );
}
